import { useEffect, useState } from 'react';
import { Descriptions, DescriptionsProps, Image } from 'antd';
import { useTranslation } from 'react-i18next';

// modals
import { Company } from 'modules/users/models/companies';

interface InputProps {
	company: Company;
}

function CompanyDetailsComponent({ company }: InputProps) {
	const { t } = useTranslation();

	const [items, setItems] = useState<DescriptionsProps['items']>([]);

	useEffect(() => {
		if (company) {
			const tempItems: DescriptionsProps['items'] = [
				{
					key: 1,
					label: t('USERS.AVERAGE_BUYING_PRICE'),
					children: company.average_buying_price,
				},
				{
					key: 'code',
					label: t('USERS.COMPANY_CODE'),
					children: company.code,
				},
				{
					key: 'founder',
					label: t('USERS.FOUNDER'),
					children: company.founder,
				},
				{
					key: 'executive',
					label: t('USERS.EXECUTIVE'),
					children: company.executive,
				},
				{
					key: 'board_of_directors',
					label: t('USERS.BOARD_OF_DIRECTORS'),
					children: company.board_of_directors,
				},
				{
					key: 'common_shares_count',
					label: t('USERS.COMMON_SHARE_COUNT'),
					children: company.common_shares_count,
				},
				{
					key: 'equity_percentage',
					label: t('USERS.EQUITY_PERCENTAGE'),
					children: company.equity_percentage.toFixed(3),
				},
				{
					key: 'free_common_shares_count',
					label: t('USERS.FREE_COMMON_SHARE_COUNT'),
					children: company.free_common_shares_count,
				},
				{
					key: 'free_preferred_shares_count',
					label: t('USERS.FREE_PREFERRED_SHARE_COUNT'),
					children: company.free_preferred_shares_count,
				},
				{
					key: 'fully_paid',
					label: t('USERS.FILLY_PAID'),
					children: company.fully_paid,
				},
				{
					key: 'mortgaged_common_shares_count',
					label: t('USERS.MORTGAGE_COMMON_SHARES_COUNT'),
					children: company.mortgaged_common_shares_count,
				},
				{
					key: 'mortgaged_preferred_shares_count',
					label: t('USERS.MORTGAGE_PREFERRED_SHARES_COUNT'),
					children: company.mortgaged_preferred_shares_count,
				},
				{
					key: 'offered_common_shares_count',
					label: t('USERS.OFFERED_COMMON_SHARES_COUNT'),
					children: company.offered_common_shares_count,
				},
				{
					key: 'preferred_shares_count',
					label: t('USERS.PREFERRED_SHARES_COUNT'),
					children: company.preferred_shares_count,
				},
				{
					key: 'purchase_cost',
					label: t('USERS.PURCHASE_COST'),
					children: company.purchase_cost,
				},
				{
					key: 'status',
					label: t('COMMON.STATUS'),
					children: company.status,
				},
				{
					key: 'suspended_common_shares_count',
					label: t('USERS.SUSPEND_COMMON_SHARES_COUNT'),
					children: company.suspended_common_shares_count,
				},
				{
					key: 'suspended_preferred_shares_count',
					label: t('USERS.SUSPEND_PREFERRED_SHARES_COUNT'),
					children: company.suspended_preferred_shares_count,
				},
			];

			setItems(tempItems);
		}
	}, [company]);

	return (
		<div className="mb-5">
			<div className="d-flex align-items-center gap-4 mt-3">
				<Image src={company.company_logo} width={100} height={100} />
				<div>
					<h2>{company.company_name}</h2>
				</div>
			</div>

			<div className="mt-5">
				<Descriptions items={items} />
			</div>
		</div>
	);
}

export default CompanyDetailsComponent;
